import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class IDragDropRecipient {
	static validate(obj){
		if(!obj)throwNotProvided('obj');
		const objTypeName = obj.constructor.name;
		if(!obj.onDrop)throw new Error(`obj of type ${objTypeName} did not expose a method named onDrop`);
		if(typeof(obj.onDrop)!=='function')throw new Error(`${objTypeName}.onDrop was not a function`);
		if(!obj.onDragging)throw new Error(`obj of type ${objTypeName} did not expose a method named onDragging`);
		if(typeof(obj.onDragging)!=='function')throw new Error(`${objTypeName}.onDragging was not a function`);
	}
}